module.exports = __webpack_public_path__ + "img/bg.aacd120c.svg";